var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"},attrs:{"id":"content"}},[_c('canvas',{ref:"canvas",staticStyle:{"width":"1000px","height":"600px"},attrs:{"id":"canvas"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }